var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-option-group',{attrs:{"value":_vm.value,"options":_vm.options,"color":"primary","inline":"","dense":"","size":"2rem"},on:{"input":function($event){return _vm.valueChanged($event, _vm.params.data, _vm.params)}}})}
var staticRenderFns = []

export { render, staticRenderFns }